import StepperInput from "components/Stepper"
import Translation from "components/Translation"
import { useAppContext } from "context/AppContext"
import { useEffect, useState } from "react"
import { LimitType, SchedulingLimit } from "types/scheduling-restrictions"
import { getTranslation } from "utils/language-helper"

type BookingLimitProps = {
    enable_limits: boolean
    toggleEnableLimits(enable: boolean): void
    scheduling_limits: SchedulingLimit,
    setSchedulingLimits(scheduling_limit: SchedulingLimit): void
}

export default function BookingLimit(props: BookingLimitProps) {
    const {
        enable_limits,
        toggleEnableLimits,
        scheduling_limits,
        setSchedulingLimits
    } = props
    const { translations } = useAppContext()
    const [daily, setDaily] = useState<number>(0)
    const [weekly, setWeekly] = useState<number>(0)
    const [monthly, setMonthly] = useState<number>(0)
    const is_staff = scheduling_limits.type == LimitType.STAFF

    useEffect(() => {
        setDaily(is_staff ? scheduling_limits.max_hours_per_day || 0 : scheduling_limits.max_count_per_day || 0)
        setWeekly(is_staff ? scheduling_limits.max_hours_per_week || 0 : scheduling_limits.max_count_per_week || 0)
        // TODO: implement monthly
    }, [scheduling_limits])

    useEffect(() => {
        let limits = scheduling_limits
        if (is_staff) {
            limits.max_hours_per_day = daily
            limits.max_hours_per_week = weekly
            // TODO: implement monthly
        } else {
            limits.max_count_per_day = daily
            limits.max_count_per_week = weekly
            // TODO: implement monthly
        }
        setSchedulingLimits(limits)
    }, [daily, weekly, monthly])

    return (
        <div className="flex flex-col items-start gap-y-4 py-5 opacity-100" >
            <div className="flex flex-row w-full gap-x-10">
                <Translation
                    content_key={is_staff ? "common.staff_limits" : "common.service_limits"}
                    render_as="div"
                    className="text-secondary-blue font-medium text-lg"
                />
                <div className="flex flex-row gap-x-3">
                    <input
                        type="checkbox"
                        className="flex h-6 w-6 border-gray-300 rounded text-secondary-blue focus:ring-primary-light"
                        // disabled={use_global_limits} //TODO: global limit support
                        checked={enable_limits}
                        onChange={() => {
                            toggleEnableLimits(!enable_limits)
                        }}
                    />

                    <Translation
                        content_key={is_staff ? "staff.enable_staff_limits" : "services.enable_service_limits"}
                        render_as="label"
                        className="flex items-center text-gray-one text-base font-[450]"
                    />
                </div>
            </div>
            {enable_limits &&
                <div className="flex flex-col w-full p-5 bg-gray-three/30 rounded-lg text-gray-one font-[450] gap-y-6">
                    <Translation
                        content_key={is_staff ? "staff.scheduling_limit_desc" : "services.scheduling_limit_desc"}
                        render_as="div"
                    />
                    <div className="flex flex-row gap-x-5">
                        {/* TODO: change to w-1/3 for monthly */}
                        <div className="flex flex-col w-1/2 gap-y-2">
                            <Translation
                                content_key="common.daily"
                            />
                            <StepperInput
                                default_value={daily}
                                helper_text={getTranslation(
                                    is_staff ? 'hours' : 'services',
                                    translations
                                )}
                                onChange={(v: number) => {
                                    setDaily(v)
                                }}
                            />
                        </div>
                        {/* TODO: change to w-1/3 for monthly */}
                        <div className="flex flex-col w-1/2 gap-y-2">
                            <Translation
                                content_key="common.weekly"
                            />
                            <StepperInput
                                default_value={weekly}
                                helper_text={getTranslation(
                                    is_staff ? 'hours' : 'services',
                                    translations
                                )}
                                onChange={(v: number) => {
                                    setWeekly(v)
                                }}
                            />
                        </div>
                        {/* TODO: implement monthly */}
                        {/* <div className="flex flex-col w-1/3 gap-y-2">
                            <Translation
                                content_key="common.monthly"
                            />
                            <StepperInput
                                default_value={monthly}
                                helper_text={getTranslation(
                                    is_staff ? 'hours' : 'services',
                                    translations
                                )}
                                onChange={(v: number) => {
                                    setMonthly(v)
                                }}
                            />
                        </div> */}
                    </div>
                </div>
            }
        </div>
    )
}